import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      name: '首页',
      leftShow: false,
      showtitle: true,
      showTabbar: true
    },
    component: () => import('../views/home.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      name: '登录',
      leftShow: false,
      showtitle: true,
      showTabbar: false
    },
    component: () => import('../views/login.vue')
  },
  {
    path: '/nutrition',
    name: 'nutrition',
    meta: {
      name: '报告',
      leftShow: false,
      showtitle: true,
      showTabbar: true
    },
    component: () => import('../views/nutrition.vue')
  },
  {
    path: '/nutritionDetail',
    name: 'nutritionDetail',
    meta: {
      name: '报告详情',
      leftShow: true,
      showtitle: true,
      showTabbar: false
    },
    component: () => import('../views/nutritionDetail.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    meta: {
      name: '协议',
      leftShow: true,
      showtitle: true,
      showTabbar: false
    },
    component: () => import('../views/agreement.vue')
  },
  {
    path: '/shop',
    name: 'shop',
    meta: {
      name: '商城',
      leftShow: false,
      showtitle: false,
      showTabbar: true
    },
    component: () => import('../views/shop.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
